import {inject, Pipe, type PipeTransform} from "@angular/core";
import type {SafeHtml} from "@angular/platform-browser";
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: "safeHtml",
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
